import trim from 'lodash/trim';

/**
 * Styled Components helper for rendering a checkmark as a background image.
 *
 * @param {object} theme - styled components theme
 * @returns {*} the image CSS
 */
export default function checkmark({theme}) {
    return `url('data:image/svg+xml;base64,${
        btoa(`
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 24 24" style="width: 24px; height: 24px; color: ${theme.color.accent20};">
                <path d="M6.843 11.207l3.536 3.536 7.778-7.779L19.57 8.38 10.38 17.57l-4.95-4.95 1.414-1.414z" fill="currentColor" fill-rule="evenodd"/>
            </svg>        
        `
            .split('\n')
            .map(trim)
            .join(''))
    }')`;
}
